import { render, staticRenderFns } from "./EditarAssociacao.vue?vue&type=template&id=2899e884"
import script from "./EditarAssociacao.vue?vue&type=script&lang=ts"
export * from "./EditarAssociacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports